import { isServer } from './is-client';
import { factoryConfig } from './config-ensurer';

export const config = (() => {
  if (isServer) return factoryConfig();

  if (!window._runtimeConfig) return factoryConfig();
  return window._runtimeConfig;
})();
